export type GlucoseView = 'loading' | 'empty' | 'error' | 'data';

export function resolveGlucoseView({
  isLoading,
  isError,
  readingCount,
}: {
  isLoading: boolean;
  isError: boolean;
  readingCount: number;
}): GlucoseView {
  if (isLoading) return 'loading';
  if (isError) return 'error';
  return readingCount > 0 ? 'data' : 'empty';
}
